export const WORDS = [
  'archerqueen',
  'archers',
  'arrows',
  'babydragon',
  'balloon',
  'bandit',
  'barbarianhut',
  'barbarians',
  'battlehealer',
  'battleram',
  'bomber',
  'bombtower',
  'bowler',
  'cannon',
  'cannoncart',
  'clone',
  'darkprince',
  'dartgoblin',
  'earthquake',
  'electrodragon',
  'electrogiant',
  'electrospirit',
  'electrowizard',
  'elixirgolem',
  'executioner',
  'firecracker',
  'firespirit',
  'fisherman',
  'flyingmachine',
  'freeze',
  'furnace',
  'giant',
  'giantskeleton',
  'giantsnowball',
  'goblinbarrel',
  'goblincage',
  'goblindrill',
  'goblingang',
  'goblingiant',
  'goblinhut',
  'goblins',
  'goldenknight',
  'golem',
  'graveyard',
  'guards',
  'healspirit',
  'hunter',
  'icespirit',
  'icewizard',
  'infernodragon',
  'infernotower',
  'knight',
  'lavahound',
  'lightning',
  'lumberjack',
  'magicarcher',
  'megaknight',
  'megaminion',
  'mightyminer',
  'miner',
  'minionhorde',
  'minions',
  'minipekka',
  'mirror',
  'mortar',
  'motherwitch',
  'musketeer',
  'nightwitch',
  'pekka',
  'poison',
  'prince',
  'rascals',
  'rocket',
  'royaldelivery',
  'royalghost',
  'royalgiant',
  'royalhogs',
  'royalrecruits',
  'skeletonarmy',
  'skeletonking',
  'skeletons',
  'sparky',
  'speargoblins',
  'tesla',
  'thelog',
  'tombstone',
  'tornado',
  'wallbreakers',
  'witch',
  'wizard',
  'zappies',
]